import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import { Image, SanitizeHtml } from '@bd/bdcore-utilities';
import { Link as RRLink } from 'react-router-dom';
import { colors, typography } from '../../styles';

const styles = css`
  padding: 50px 0;
  @media(min-width: 992px) {
    padding: 80px 0;
  }
  .SpecialResults_headline {
    font-weight: 700;
    font-size: 24px;
    color: ${colors.brand2};
    font-family: ${typography.Serif};
    letter-spacing: 0;
    line-height: 32px;
    padding: 0 0 15px 0;
    @media(min-width: 992px) {
      font-size: 34px;
      line-height: 43px;
      padding: 0 0 25px 0;
    }
  }
  .SpecialResults_disclaimer {
    font-size: 13px;
    line-height: 20px;
    font-weight: 300;
    color: ${colors.brand3};
    margin: 15px 0 0 0;
    @media(min-width: 992px) {
      margin: 25px 0 0 0;
    }
  }
  .SpecialResults_btn {
    width: 100%;
    height: auto;
    padding: 15px 30px;
    @media(min-width: 576px) {
      height: 45px;
      padding: 0 30px;
      width: max-content;
    }
  }
  .SpecialResults_image {
    max-width: 500px;
    @media(min-width: 992px) {
      max-width: none;
    }
  }
  .SpecialOffers_body{
    ul {
      list-style-type: none;
      padding: 0 0 30px;

      li {
        list-style-type: none;
        padding: 5px 0;
        border-bottom: 1px solid ${colors.whiteDarker};
        font-weight: 300;
      }

      li:last-child {
        border: 0;
      }

      li:before {
        font-family: "arial", sans-serif;
        content: '\\25AA';
        color: ${colors.brand1};
        padding-right: 5px;
        font-size: 20px;
      }
    }
  }
`;

function SpecialsResults({ special }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row">
          {
            get(special, 'image.contentUrl') &&
            <div className="col-lg-6 d-flex justify-content-center align-items-lg-start">
              <Image
                src={get(special, 'image.contentUrl')}
                alt={get(special, 'image.name', get(special, 'image.caption', ''))}
                className="w-100 mb-4 mb-lg-0 SpecialResults_image"
              />
            </div>
          }
          <div className="col-lg-6 ml-auto d-flex flex-column">
            <div className="">
              {
                get(special, 'headline') &&
                <h3 className="SpecialResults_headline">{get(special, 'headline')}</h3>
              }
              <div className="SpecialOffers_body" dangerouslySetInnerHTML={SanitizeHtml(get(special, 'copy', ''))} />
              <ul className="list-unstyled">
                {
                  get(special, 'buttons') &&
                  get(special, 'buttons').map(btn => (
                    <li key={btn._id}>
                      {
                        get(btn, 'button_route') &&
                        get(btn, 'button_label') &&
                        <RRLink to={get(btn, 'button_route')} className="btn my-3">{get(btn, 'button_label')}</RRLink>
                      }
                    </li>
                  ))
                }
              </ul>
              <div className="SpecialResults_disclaimer" dangerouslySetInnerHTML={SanitizeHtml(get(special, 'disclaimer_text', ''))} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SpecialsResults.propTypes = {
  special: PropTypes.object.isRequired,
};

export default SpecialsResults;



// WEBPACK FOOTER //
// ./src/pages/SpecialOffersDetail/SpecialResults.js